import { TreeNode } from 'primeng/api';
import { FilterTypes, FinancialCriteriaOptions } from '../../../models/filterEnums.model';
import { Ratio } from '../../../models/ratio.model';
import { VendorAccount } from '../../../models/vendoraccount.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class FinancialCriteria extends FilterCriteria {
  public override title = 'Financial';
  public override type: FilterTypes = FilterTypes.Financial;
  minimumValue: number = null;
  maximumValue: number = null;
  criteriaSelection: string = FinancialCriteriaOptions.DataAvailability;
  vendorAccount: VendorAccount = new VendorAccount();
  ratio: Ratio = new Ratio();
  vendorAccountId: number = null;
  ratioId: number = null;
  hasAverageForSelectedYears = false;
  public override selectedAbsoluteYr: TreeNode[] = null;
  allSelectedYear: number = null;
  isPassIfNa?: boolean = null;
  isCurrentPlusPriorYearBalanceSheetItem?: boolean = null;

  public override validate(): boolean {
    if (this.criteriaSelection.length <= 0) {
      return false;
    }
    if (this.allSelectedYear === undefined || this.allSelectedYear === null || this.allSelectedYear <= 0) {
      return false;
    }
    if (!this.validateMinMax()) {
      return false;
    }
    if (this.criteriaSelection === FinancialCriteriaOptions.DataAvailability) {
      return this.vendorAccountId != null && this.vendorAccountId > 0;
    }
    if (this.criteriaSelection === FinancialCriteriaOptions.FinancialRatio) {
      return this.ratioId != null && this.ratioId > 0;
    }
    if (this.criteriaSelection === FinancialCriteriaOptions.FinancialItem) {
      return this.vendorAccountId != null && this.vendorAccountId > 0;
    }
    return true;
  }

  public override toString(): string {
    const s: string[] = [];
    s.push(this.criteriaSelection);

    if (this.criteriaSelection === FinancialCriteriaOptions.DataAvailability) {
      s.push('Vendor account: ' + this.vendorAccount.name);
    }
    if (this.criteriaSelection === FinancialCriteriaOptions.FinancialRatio) {
      s.push('Ratio: ' + this.ratio.name);
    }
    if (this.criteriaSelection === FinancialCriteriaOptions.FinancialItem) {
      s.push('Vendor account: ' + this.vendorAccount.name);
    }
    if (this.selectedAbsoluteYr && this.selectedAbsoluteYr.length > 0) {
      s.push('Absolute Years: ' + this.selectedAbsoluteYr.map((selection) => selection.label).join(', '));
    }
    if (this.allSelectedYear) {
      s.push('Criteria to be valid: ' + this.allSelectedYear);
    }
    if (this.minimumValue != null && this.minimumValue >= 0) {
      s.push('Minimum Value: ' + this.minimumValue);
    }
    if (this.maximumValue != null && this.maximumValue >= 0) {
      s.push('Maximum Value: ' + this.maximumValue);
    }
    if (this.isCurrentPlusPriorYearBalanceSheetItem !== null) {
      const selectedValue = this.isCurrentPlusPriorYearBalanceSheetItem ? '(CY+PY)/2' : 'CY Only';
      s.push('Balance Sheet Item Value: ' + selectedValue);
    }

    return s.join(' | ');
  }

  private validateMinMax() {
    if (this.criteriaSelection === FinancialCriteriaOptions.FinancialRatio || this.criteriaSelection === FinancialCriteriaOptions.FinancialItem) {
      return (this.minimumValue != null && this.minimumValue >= 0) || (this.maximumValue != null && this.maximumValue >= 0);
    } else {
      return true;
    }
  }
}
